import http from '../Api/http';

const filenameFromDisposition = (cd) => {
    if (!cd) return '';
    const star = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(cd);
    if (star) return decodeURIComponent(star[1].replace(/["']/g, '').trim());
    const plain = /filename="?([^";]+)"?/i.exec(cd);
    return plain ? plain[1].trim() : '';
};

export const fetchFileBlob = async (url, params) => {
    const res = await http.get(url, { params, responseType: 'blob' });
    return { blob: res.data, name: filenameFromDisposition(res.headers?.['content-disposition']) };
};

export const blobErrorMessage = async (err, fallback = 'Could not download the file.') => {
    const data = err?.response?.data;
    if (data instanceof Blob) {
        try {
            const text = await data.text();
            const json = JSON.parse(text);
            return json?.message || json?.error?.message || fallback;
        } catch { }
    }
    if (err?.response?.status === 404) return 'That file is no longer available.';
    if (err?.request && !err?.response) return 'Cannot reach the server. Check your connection and try again.';
    return fallback;
};

export const saveBlob = (blob, filename) => {
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename || 'download';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
};

export const showBlobInWindow = (win, blob) => {
    if (!win) return false;
    const objectUrl = URL.createObjectURL(blob);
    win.location.href = objectUrl;
    setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
    return true;
};
